import { Controller } from "@hotwired/stimulus";

// Auto-generates a visit name from cycle (group_name) and day_number.
// Handles cycle selection from dropdown or custom text input.
// If the user manually edits the name field, auto-generation stops.
export default class extends Controller {
  static targets = ["cycleSelect", "customCycle", "dayNumber", "name", "groupValue"];

  connect() {
    this._manuallyEdited = false;
  }

  cycleChanged() {
    const selected = this.cycleSelectTarget.value;
    if (selected === "__new__") {
      this.customCycleTarget.classList.remove("d-none");
      this.customCycleTarget.focus();
      this.groupValueTarget.value = "";
    } else {
      this.customCycleTarget.classList.add("d-none");
      this.customCycleTarget.value = "";
      this.groupValueTarget.value = selected;
    }
    this._updateName();
  }

  customCycleChanged() {
    this.groupValueTarget.value = this.customCycleTarget.value.trim();
    this._updateName();
  }

  dayChanged() {
    this._updateName();
  }

  markManual() {
    this._manuallyEdited = true;
  }

  _updateName() {
    if (this._manuallyEdited) return;

    const cycle = this.groupValueTarget.value.trim();
    const day = this.dayNumberTarget.value.trim();

    if (cycle && day) {
      this.nameTarget.value = `${cycle} Day ${day}`;
    } else if (cycle) {
      this.nameTarget.value = cycle;
    } else {
      this.nameTarget.value = "";
    }
  }
}
